export { emit, GameEvents, off, on } from "./events/eventBus.js";
import { initCraftingEvents } from "./events/craftingEvents.js";
import { initFightEvents } from "./events/fightEvents.js";

export function initEventListeners(gameStore, inventoryStore) {
  initFightEvents(gameStore, inventoryStore);
  initCraftingEvents(gameStore, inventoryStore);
}
